<script setup lang="ts"></script>

<template>
  <h2 class="font-pragmatica-ext mb-8 text-xl font-bold">
    <slot />
  </h2>
</template>
